<template lang="pug">
v-card
  v-card-title.d-flex.justify-center(style='color:#222222; font-weight: 700; font-size: 20px;') {{$t('ADD_SUPERUSER.TITLE')}}
  v-card-text
    v-form(v-model="valid", ref="form")
      // tenant
      v-row.mt-4
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.TENANTNAME')}}
        v-col.pa-0
          v-select(
            v-model='selectTanent' 
            outlined,
            :items='tenantListItems',
            item-text='name',
            item-value='name',
            :placeholder=`$t('ADD_SUPERUSER.SELECT_TENANT')`,
            dense,
            required='required',
            :disabled='addBtn_loading'
            )

      // user name
      //- v-row
      //-   v-col.pa-0(cols='12').d-flex.justify-start
      //-     div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.USERNAME')}}
      //-   v-col.pa-0
      //-     v-text-field.mb-0(
      //-       v-model='addData.username',
      //-       :placeholder=`$t('ADD_SUPERUSER.USERNAME')`,
      //-       outlined,
      //-       dense
      //-       required='required',
      //-     )
      // last name
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.LASTNAME')}}
        v-col.pa-0
          v-text-field.input-fontsize-small.mb-0(
            v-model='addData.last_name',
            :placeholder=`$t('ADD_SUPERUSER.LASTNAME')`,
            type='text',
            outlined,
            dense
            :rules='formRule.lastNameRules',
            required='required',
            :disabled='addBtn_loading'
            font-size='small'
          )
      // first name
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.FIRSTNAME')}}
        v-col.pa-0
          v-text-field.input-fontsize-small.mb-0(
            v-model='addData.first_name',
            :placeholder=`$t('ADD_SUPERUSER.FIRSTNAME')`,
            type='text',
            outlined,
            dense
            :rules='formRule.firstNameRules',
            required='required',
            :disabled='addBtn_loading'
            font-size='small'
          )
      // email
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.EMAIL')}}
        v-col.pa-0
          v-text-field.input-fontsize-small.mb-0(
            v-model='addData.email',
            :placeholder=`$t('ADD_SUPERUSER.EMAIL')`,
            type='email',
            outlined,
            dense
            :rules='formRule.emailRulesX',
            required='required',
            :disabled='addBtn_loading'
            font-size='small'
          )
      // password
      v-row
        v-col.pa-0(cols='12').d-flex.justify-start
          div(style='color:#444444; font-weight: 500; font-size: 14px;') {{$t('ADD_SUPERUSER.PASSWORD')}}
        v-col.pa-0
          v-text-field.input-fontsize-small.mb-2(
            v-model='addData.password',
            :placeholder=`$t('ADD_SUPERUSER.PASSWORD')`,
            :type='passwordType',
            :append-icon='iconType'
            @click:append="showPwd"
            outlined,
            dense
            :rules='formRule.passwordRules',
            required='required',
            :hint=`$t('ADD_SUPERUSER.PASSWORD__HINT')`
            persistent-hint
            :disabled='addBtn_loading'
            font-size='small'
          )
        //- Upchat
      v-row.mb-2
        v-col.pa-0(cols='12').d-flex.justify-start
          v-checkbox.no-border.mt-0(v-model='addData.createUpchat' )
          span.ml-2.mt-1 Upchat  
    div.d-flex.align-center.justify-end(style='background-color: #f4f4f4; width: 480px; height:60px; margin-left:-24px; margin-bottom: -20px;')
      v-btn.mr-4(
        :ripple="false",
        @click="onCancel",
        width="100",
        height="40",
        color="cancel",
        depressed,
        outlined,
        style='font-weight: 700;'
        :disabled='addBtn_loading'
      ) {{$t('GENERAL.CANCEL')}}
      v-btn.mr-6(
        :ripple="false",
        @click="onConfirm",
        width="100",
        height="40",
        color="#14C6DE",
        depressed,
        dark,
      ) 
        v-progress-circular(v-if='addBtn_loading' indeterminate size='20')
        .t-white(v-else style='font-weight: 700;') {{$t('TENANTCENTER.CREATE')}}

  v-dialog(v-model='messageDialog' width='360' content-class='statusDialog' v-if='messageDialog')
    message-dialog(@emitMessageDialog='onEmitMessageDialog' :message='message' )
  v-dialog(v-model='errorDialog' width='360' content-class='statusDialog' @keydown.esc='onEmitErrorDialog(false)' @keydown.enter='onEmitErrorDialog(true)')
    error-dialog(@emitErrorDialog='onEmitErrorDialog' :errorMessage='errorMessage')
  v-dialog(v-model='successDialog' width='360' content-class='statusDialog' @keydown.enter='onEmitSuccessDialog(true)')
    success-dialog(@emitSuccessDialog='onEmitSuccessDialog')
</template>

<script>
import Vue from "vue";
import messageDialog from '@/components/Dialog/redirectDialog';
import errorDialog from "@/components/Dialog/errorDialog";
import successDialog from "@/components/Dialog/successDialog";
import i18n from '/common/plugins/vue-i18n.js';
import TenantCenterService from "@/services/TenantCenterService";


export default Vue.extend({
  props: {
    tenantListItems: {
      type: Array,
      require: true,
    },
  },
  components: {            
      messageDialog,
      errorDialog,
      successDialog
  },
  data() {
    return {
      addBtn_loading:false,
      addData : {createUpchat: true},
      messageDialog:false,
      message:"",
      errorDialog: false,
      errorMessage: "",
      successDialog: false,
      valid: true,
      formRule: {
        nameRules: [
            (v) => !!v || i18n.t('RULE.RULE_R'),
            (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100'),
            (v) => /^[a-z0-9_]+$/.test(v) || i18n.t('RULE.RULE_LOWER_ALPHA_NUMERIC'),
        ],
        passwordRules:[
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,30}/.test(v) || i18n.t('ADD_SUPERUSER.PASSWORD__HINT'),
        ],
        emailRulesX: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$|(^$)|null/.test(v) || i18n.t('RULE.RULE_EMAIL'),
          (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
        ],
        descriptionRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,100}$/.test(v) || i18n.t('RULE.RULE_100')
        ],
        categoryRules: [
          (v) => !!v || i18n.t('RULE.RULE_R'),
          (v) => /^.{0,30}$/.test(v) || i18n.t('RULE.RULE_30')
        ],
        lastNameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R_LASTNAME_3'),
          (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
        ],
        firstNameRules: [
          (v) => !!v || i18n.t('RULE.RULE_R_FIRSTNAME'),
          (v) => /^.{0,50}$/.test(v) || i18n.t('RULE.RULE_50')
        ],
      },
      enterTenant:"",
      tenantList:[],
      passwordType: "password",
      iconType:"fa fa-eye-slash",
      selectTanent:""
    };
  },
  async created(){
  },
  methods: {
    validateForm() {
      if (this.$refs.form.validate()) 
        return true;
      else 
        return false;
    },
    async onConfirm() {
      if (this.validateForm() && !this.addBtn_loading) {
        this.addBtn_loading = true;
        this.addData.username = this.addData.email;
        this.addData.schema_name = this.selectTanent;
        console.log('this.addData', this.addData)
        TenantCenterService.createSuperUser(this.addData).then(()=>{
          this.showSuccessDialog();
        })
        .catch(error => {
          let error_msg = error.response.data.error
          this.showErrorDialog(error_msg);
        })

      }
    },
    onCancel() {     
      this.$emit("emitAddSuperUserDialog", false);
    },
    showMessageDialog(msg) {                
        this.messageDialog = true;
        this.message = msg;
    },
    async onEmitMessageDialog(val) {
      if(val){
        // 
      }
    },
    showErrorDialog(message) {
      this.errorDialog = true;
      this.errorMessage = message;
    },
    onEmitErrorDialog() {
      this.errorDialog = false;
      this.addBtn_loading = false;
    },
    showSuccessDialog() {
      this.successDialog = true;
    },
    async onEmitSuccessDialog() {
      this.$emit("emitAddSuperUserDialog", false);
      this.successDialog = false;
    },
    showPwd() {
      if (this.passwordType === "password") {
        this.passwordType = "text";
        this.iconType ="fa fa-eye"
      } else {
        this.passwordType = "password";
        this.iconType ="fa fa-eye-slash"
      }      
    },
  },
});
</script>